import { VoiceAssistantFormEnum } from '@zaoblako/shared/modules/ai/enums/voice-assistant-form.enum';
import type { ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';
import type { HelpdeskTaskTypeFindInterface } from '@zaoblako/shared/modules/helpdesk/dto/task-type/helpdesk-task-type-find.dto';
import type { ContractFindInterface } from '@zaoblako/shared/modules/document/dtos/contract/contract-find.dto';

import { Injectable } from '@angular/core';
import { Subject, type Observable } from 'rxjs';

export type FormSubscriptionPayload<Form extends VoiceAssistantFormEnum> =
  Form extends VoiceAssistantFormEnum.CONTRAGENT ? ContragentFindInterface
  : Form extends VoiceAssistantFormEnum.CLIENT ? ClientFindInterface
  : Form extends VoiceAssistantFormEnum.HD_TASK_TYPE ? HelpdeskTaskTypeFindInterface
  : Form extends VoiceAssistantFormEnum.CONTRACT ? ContractFindInterface
  : never;

export type FormSubjects = {
  [Form in VoiceAssistantFormEnum]: Subject<FormSubscriptionPayload<Form>>;
};

/** Provides "bridge" between components to handle events of the form triggered by voice assistant */
@Injectable({ providedIn: 'root' })
export class VoiceAssistantBridgeService {
  private readonly subjects: FormSubjects = {
    [VoiceAssistantFormEnum.CONTRAGENT]: new Subject(),
    [VoiceAssistantFormEnum.CLIENT]: new Subject(),
    [VoiceAssistantFormEnum.HD_TASK_TYPE]: new Subject(),
    [VoiceAssistantFormEnum.CONTRACT]: new Subject()
  };

  public onFormSave<Form extends VoiceAssistantFormEnum = VoiceAssistantFormEnum>(form: Form): Observable<FormSubscriptionPayload<Form>> {
    return this.subjects[form].asObservable();
  }

  public formSaved<Form extends VoiceAssistantFormEnum = VoiceAssistantFormEnum>(form: Form, payload: FormSubscriptionPayload<Form>) {
    this.subjects[form].next(payload);
  }
}
